module.exports = __webpack_public_path__ + "static/media/INDUSTRIAS GRANFINO.62140248.svg";